import { withNamespaces } from 'react-i18next';
import {
    Button,
    Card,
    CardBody,
} from 'reactstrap';

const RequestInformation = ({
    t,
}) => {
    return (
        <Card>
            <CardBody>
                <h5>{t('Request information from carrier')}</h5>
                <p className="text-muted">
                    {t('Send a message to the carrier to provide the missing information.')}
                </p>
                <Button color="primary" type="button">
                    <i className="ri-mail-send-line align-middle me-1" />
                    {t('Request information')}
                </Button>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    RequestInformation
);
